export const SUBSCRIPTION_PLANS = {
  Trial: { price: "$0 / month", allowedAgents: 1 },
  Standard: { price: "$49 / month", allowedAgents: 3 },
  Premium: { price: "$149 / month", allowedAgents: 10 },
  Enterprise: { price: "Custom pricing", allowedAgents: "Unlimited" },
};

export const SUBSCRIPTION_TYPES = Object.keys(SUBSCRIPTION_PLANS);

export const DEFAULT_MODULES = ["Dashboard", "Agents", "Leads", "Configuration"];

export const PAYMENT_TYPES = [
  "Credit Card",
  "Bank Transfer",
  "Cheque",
  "Cash",
  "Online Payment",
];

export function getTodayDateValue() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysToDateValue(dateValue, days) {
  const date = new Date(`${dateValue}T00:00:00`);
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
}

export function generateContractRef() {
  const digits = Math.floor(1000000 + Math.random() * 9000000);
  return `AVACO-${digits}`;
}
